import { IBasicOption, IBookingLocation } from "../../types";
import { ISortBy } from "../../api/types";

// enum dashboard tabs
export enum DASHBOARD_TABS {
    PENDING_BOOKINGS_BY_LOCATIONS,
    PENDING_BOOKINGS_BY_SEGMENT_AND_CATEGORY,
    MOBILITY_STORE_ACTIVITIES_FOR_REGION
}

// default time for property avgWorkingTime and maxWorkingTime
export const DEFAULT_TIME = '00:00';

// interface for filter dashboard tab pending bookings by location
export interface IFormValuesPendingBookingsByLocationListDashboardFilter {
    segments: IBasicOption[];
    categories: IBasicOption[];
    products: IBasicOption[];
    pickupLocations: IBookingLocation[];
    tenants?: string[];
    dealers?: string[];
}

// interface for filter dashboard tab pending bookings by segment
export interface IFormValuesPendingBookingsBySegmentListDashboardFilter {
    pickupLocations: IBookingLocation[];
    tenants?: string[];
    dealers?: string[];
}

// interface for filter dashboard tab ms activities by region
export interface IFormValuesMsActivitiesByRegionListDashboardFilter {
    segments: IBasicOption[];
    categories: IBasicOption[];
    products: IBasicOption[];
    tenants?: string[];
    dealers?: string[];
}

// interface for response total bookings header dashboard
export interface ITotalBookingsDashboard {
    pending: number;
    worked: number;
    avgWorkingTime: string;
    maxWorkingTime: string;
    maxIdleTime: string;
}

// interface for param apply dashboard table
export interface IGetPendingBookingsListParams {
    filters: IFormValuesPendingBookingsByLocationListDashboardFilter | IFormValuesPendingBookingsBySegmentListDashboardFilter | IFormValuesMsActivitiesByRegionListDashboardFilter,
    sortBy?: ISortBy,
    start?: number,
    limit?: number
}

// interface for param apply pinned row
export interface IGetPendingBookingTotalParams {
    filters: IFormValuesPendingBookingsByLocationListDashboardFilter | IFormValuesPendingBookingsBySegmentListDashboardFilter | IFormValuesMsActivitiesByRegionListDashboardFilter,
}

/**
 * Pending bookings by locations interface
 */
// interface for response pending booking by locations list
export interface IPendingBookingsByLocationsList {
    location: string;
    tot: number;
    toBeWorked: number;
    maxIdleTime: string;
    maxWorkingTime: string;
    confirmed: number;
    rejectedUnavailable: number;
    worked: number;
    avgWorkingTime: string;
    bookingInserted: number;
    offersInserted: number;
}

// interface for response total of pending booking by locations
export interface ITotalPendingBookingsByLocations {
    totalRecords: number;
    tot: number;
    toBeWorked: number;
    maxIdleTime: string;
    maxWorkingTime: string;
    confirmed: number;
    rejectedUnavailable: number;
    worked: number;
    avgWorkingTime: string;
    bookingInserted: number;
    offersInserted: number;
}

/**
 * Pending bookings by segment and category interface
 */
// interface for response mobility store activities by region list
export interface IPendingBookingsBySegmentAndCategoryList {
    root: IPendingBookingsBySegmentAndCategory,
    children: IPendingBookingsBySegmentAndCategory[]
}

// interface for response pending booking by segment and category list
export interface IPendingBookingsBySegmentAndCategory {
    segment: string;
    category?: string;
    tot: number;
    toBeWorked: number;
    maxIdleTime: string;
    maxWorkingTime: string;
    confirmed: number;
    rejectedUnavailable: number;
    worked: number;
    avgWorkingTime: string;
    children?:IPendingBookingsBySegmentAndCategory[];
}

// interface for response total of pending booking by segment and category
export interface ITotalPendingBookingsBySegmentAndCategory {
    totalRecords: number;
    tot: number;
    toBeWorked: number;
    maxIdleTime: string;
    maxWorkingTime: string;
    confirmed: number;
    rejectedUnavailable: number;
    worked: number;
    avgWorkingTime: string;
}

/**
 * Mobility store activities by region interfaces
 */
// interface for response mobility store activities by region list
export interface IMobilityStoreActivitiesByRegionList {
    root: IMobilityStoreActivitiesByRegion,
    children: IMobilityStoreActivitiesByRegion[]
}

// interface for response mobility store activities by region
export interface IMobilityStoreActivitiesByRegion {
    region: string;
    city?: string;
    offers: number;
    inserted: number;
    cancelled: number;
    fleetFail: number;
    noShow: number;
    customerFail: number;
    unfullfilled: number;
    children?: IMobilityStoreActivitiesByRegion[];
}

// interface for response total of mobility store activities by region
export interface ITotalMobilityStoreActivitiesByRegion {
    totalRecords: number;
    offers: number;
    inserted: number;
    cancelled: number;
    fleetFail: number;
    noShow: number;
    customerFail: number;
    unfullfilled: number;
}
